<ion-app>

  <ion-menu side="start" contentId="main">
  <app-menu></app-menu>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
